"use strict";

//
// Flatpickr
//
